import { render, staticRenderFns } from "./ProjectTestModeModal.vue?vue&type=template&id=9640453a&"
import script from "./ProjectTestModeModal.vue?vue&type=script&lang=js&"
export * from "./ProjectTestModeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports